import { ChampignonsManagement } from '@repo/ui/features/champignons/index';

export default function ChampignonsPage() {
  return (
    <div className="">
      <ChampignonsManagement />
    </div>
  );
}

